// extracted by mini-css-extract-plugin
export default {"paper":"FiltersActionPopper_paper__2fJKk","item":"FiltersActionPopper_item__NwP2r","icon":"FiltersActionPopper_icon__aeQBu"};